<dx-load-panel [(visible)]="visible">
  <dxo-position of="#screen">
  </dxo-position>
  <div *dxTemplate="let data of 'content'">
    <pdi-loader size="medium"></pdi-loader>
  </div>
</dx-load-panel>